import { PROTOCOL_EVENT_TYPE as PET } from "../protocol/protocolEventTypes.js";
/**
 * CONTROLLER_EVENT_TYPE
 * ---------------------
 *
 * Reducer-facing event vocabulary for the call prototype.
 *
 * Event sources:
 * - Protocol / signaling notifications from the server
 * - Local signaling transport lifecycle
 * - Local media subsystem observations
 * - Local RTC subsystem observations
 *
 * IMPORTANT:
 * These are facts observed by the controller/reducer,
 * not user intents / commands.
 *
 * observedAtTs:
 * - Used on events where the reducer needs a stable observation timestamp
 * - Preserves reducer purity by avoiding Date.now() inside reducer logic
 */
export const CONTROLLER_EVENT_TYPE = {
    // Transport / signaling lifecycle
    SIGNALING_CONNECT_STARTED: "SIGNALING_CONNECT_STARTED",
    SIGNALING_TRANSPORT_OPENED: "SIGNALING_TRANSPORT_OPENED",
    SIGNALING_TRANSPORT_CLOSED: "SIGNALING_TRANSPORT_CLOSED",
    SIGNALING_RESUME_STARTED: "SIGNALING_RESUME_STARTED",
    // Protocol / server events
    WELCOME_RECEIVED: PET.WELCOME_RECEIVED,
    ERROR_RECEIVED: PET.ERROR_RECEIVED,
    PONG_RECEIVED: PET.PONG_RECEIVED,
    CALL_CREATED_RECEIVED: PET.CALL_CREATED_RECEIVED,
    CALL_INCOMING_RECEIVED: PET.CALL_INCOMING_RECEIVED,
    CALL_ACCEPTED_RECEIVED: PET.CALL_ACCEPTED_RECEIVED,
    CALL_RECONNECTING_RECEIVED: PET.CALL_RECONNECTING_RECEIVED,
    CALL_IN_CALL_RECEIVED: PET.CALL_IN_CALL_RECEIVED,
    CALL_RESUMED_RECEIVED: PET.CALL_RESUMED_RECEIVED,
    CALL_ENDED_RECEIVED: PET.CALL_ENDED_RECEIVED,
    SDP_OFFER_RECEIVED: PET.SDP_OFFER_RECEIVED,
    SDP_ANSWER_RECEIVED: PET.SDP_ANSWER_RECEIVED,
    ICE_CANDIDATE_RECEIVED: PET.ICE_CANDIDATE_RECEIVED,
    CALL_STATE_RECEIVED: PET.CALL_STATE_RECEIVED,
    // Media observations
    MEDIA_ACQUIRE_STARTED: "MEDIA_ACQUIRE_STARTED",
    MEDIA_ACQUIRE_SUCCEEDED: "MEDIA_ACQUIRE_SUCCEEDED",
    MEDIA_ACQUIRE_FAILED: "MEDIA_ACQUIRE_FAILED",
    MEDIA_DEVICES_UPDATED: "MEDIA_DEVICES_UPDATED",
    MEDIA_SELECTED_DEVICES_UPDATED: "MEDIA_SELECTED_DEVICES_UPDATED",
    LOCAL_AUDIO_ENABLED_CHANGED: "LOCAL_AUDIO_ENABLED_CHANGED",
    LOCAL_VIDEO_ENABLED_CHANGED: "LOCAL_VIDEO_ENABLED_CHANGED",
    LOCAL_SPEAKING_DETECTED: "LOCAL_SPEAKING_DETECTED",
    // RTC observations
    RTC_CONNECTION_STATE_CHANGED: "RTC_CONNECTION_STATE_CHANGED",
    RTC_ICE_GATHERING_STATE_CHANGED: "RTC_ICE_GATHERING_STATE_CHANGED",
    RTC_LOCAL_DESCRIPTION_SET: "RTC_LOCAL_DESCRIPTION_SET",
    RTC_REMOTE_DESCRIPTION_SET: "RTC_REMOTE_DESCRIPTION_SET",
    RTC_REMOTE_MEDIA_UPDATED: "RTC_REMOTE_MEDIA_UPDATED",
    RTC_NEGOTIATION_NEEDED_CHANGED: "RTC_NEGOTIATION_NEEDED_CHANGED",
    RTC_MAKING_OFFER_CHANGED: "RTC_MAKING_OFFER_CHANGED",
    RTC_SETTING_REMOTE_ANSWER_PENDING_CHANGED: "RTC_SETTING_REMOTE_ANSWER_PENDING_CHANGED",
    RTC_ERROR_OCCURRED: "RTC_ERROR_OCCURRED",
};
